import React, { useEffect } from "react";
import Img from '../assets/graduates.jpg';
import { Box, CircularProgress, useTheme } from "@mui/material";
import { env } from "../config/env";

export const Graduates = () => {
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{width: "80%", margin: "auto"}}>
      <br />
      <Box
        component="img"
        src={Img}
        alt="Landscape"
        sx={{
          width: "100%",
          maxWidth: "800px",
          height: "auto",
          display: "block",
          margin: "auto",
          borderRadius: "8px",

          [theme.breakpoints.down("sm")]: {
            maxWidth: "90%",
            borderRadius: "4px",
          },
        }}
      />

      <div id="spinner">
        <CircularProgress />
      </div>
      <div className="iframe-container">
        <iframe
          src={env.graduatesLink}
          allowFullScreen={true}
          onLoad={() => {
            document.getElementById('spinner')!.style.display = 'none';
          }}
        >
        </iframe>
      </div>
    </div>
  );
}